module.exports = __webpack_public_path__ + "static/media/footer-instagram.6f845fc3.svg";